import { api } from "@/services/api"

import { Organization } from "../types"

const ORGANIZATION_API_PATH = "/auth/organizations"

export const organizationService = {
  getOrganizationById: async (organizationId: string): Promise<Organization> => {
    if (!organizationId) {
      throw new Error("Organization ID is required to fetch organization details.")
    }
    const response = await api.get<Organization>(`${ORGANIZATION_API_PATH}/${organizationId}`)
    return response.data
  },

  updateOrganizationDetails: async (
    organizationId: string,
    payload: Partial<
      Pick<Organization, "name" | "whatsapp" | "timezone" | "restrict_attendants_to_assigned">
    >
  ): Promise<Organization> => {
    if (!organizationId) {
      throw new Error("Organization ID is required to update organization details.")
    }
    const response = await api.put<Organization>(
      `${ORGANIZATION_API_PATH}/${organizationId}`,
      payload
    )
    return response.data
  },
}
